import '@adyen/adyen-web/styles/adyen.css';
import { AdyenCheckout, Blik, BcmcMobile } from '@adyen/adyen-web';

const defaultLanguage = 'en-US';

AdyenCheckout.register(Blik, BcmcMobile);

export const getCheckoutInstance = async (adyenConfig, onAdditionalDetails, onError) => {
    const { clientKey, useLiveMode } = adyenConfig;

    const adyenCheckoutInstance = await AdyenCheckout(
        {
            countryCode: defaultLanguage,
            locale: defaultLanguage,
            environment: useLiveMode ? 'live' : 'test',
            clientKey,
            onAdditionalDetails,
            onError,
        },
    );

    return adyenCheckoutInstance;
};

export const threeDSConfiguration = {
    size: '05', // ['100%', '100%'] - The default window size
};